export enum QTY_CHANGE_ACTION_TYPE {
    INCREMENT = "INC",
    DECREMENT = "DEC",
    QTY_CHANGE = "QTY_CHANGE",
}

export const MAX_INPUT_QTY = 3;

export const CART_ITEM_IMAGE_SIZE = {
    SMALL: 40,
    BIG: {
        HEIGHT: 76,
        WIDTH: 80,
    },
};

export const CART_ITEM_IMAGE_PLACEHOLDER = "portal/m/spoonfork.png";

export const DEAL_RUSH = "DEAL_RUSH";
export const MAGIC_ITEMS = "MAGIC_ITEMS";
export const WARNING_COLOR = "warning";

export const OFFER_LIMIT_REACHED_TEXT = "Offer limit";

export const TEXT = {
    REMOVE: "REMOVE",
    FREEITEM: "FREE ITEM",
};
